import {useAtom} from 'jotai';
import {mapActionModeAtom} from '@/map/atom';
import {MapActionTypes} from '@/map/enums';
import {StreetLayer} from '@/map/modules/Layer';

export const StreetView = ({map}: {map: naver.maps.Map}) => {
  const [action, setActionMode] = useAtom(mapActionModeAtom);

  if (!map || action?.mode !== MapActionTypes.street) {
    return null;
  }

  return <StreetLayer map={map} onFinish={() => setActionMode(null)} />;
};
